import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "text-3xl font-black text-white text-center w-10/12" }, "Enter your details", -1)
const _hoisted_2 = { class: "w-full align-middle mt-5 flex flex-col gap-6 bg-white shadow-base h-fit rounded-3xl px-5 py-10" }
const _hoisted_3 = { class: "flex gap-2 w-full" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "flex-grow" }, null, -1)

import { computed } from "vue"
  import { generateSchema } from "@/utils/validate"
  import { useAccountStore } from "@/store/account"
  import { useUserStore } from "@/store/user"
  import * as jwt from "@/utils/jwt"

  import WbTemplate from "@/components/account-creation/template.vue"
  import FormContainer from "@/components/template/formTemplate.vue"
  import RadioContainer from "@/components/template/CapsuleTemplate.vue"
  import InputContainer from "@/components/template/InputTemplate.vue"
  import LocationContainer from "@/components/template/locationTemplate.vue"

  
export default /*#__PURE__*/_defineComponent({
  __name: 'DetailsPage',
  setup(__props) {

  const accountStore = useAccountStore()
  const userStore = useUserStore()

  const details = computed({
    get: () => userStore.customerDetails,
    set: (val) => {
      userStore.setCustomerDetails(val)
    },
  })

  const validationSchema = generateSchema([
    {
      name: "firstName",
      rule: "stringRequired",
    },
    {
      name: "lastName",
      rule: "stringRequired",
    },
  ])

  const genderOption = [
    {
      name: "Male",
      icon: "workbean-male",
      value: "male",
    },
    {
      name: "Female",
      icon: "workbean-female",
      value: "female",
    },
    {
      name: "LGBTQA+",
      value: "non-binary",
    },
  ]

  const setLocation = (event: any) => {
    userStore.customerDetails.profile.address = event
  }

  const saveDetails = () => {
    userStore.saveCustomerDetails(jwt.default.generateNBF()).then((success) => {
      if (success) {
        accountStore.updateOnboardingCompletion(true, jwt.default.generateNBF()).then(() => {
          window.location.href = "/workbean-world"
        })
      }
    })
  }

return (_ctx: any,_cache: any) => {
  const _component_ion_button = _resolveComponent("ion-button")!

  return (_openBlock(), _createBlock(WbTemplate, null, {
    default: _withCtx(() => [
      _createVNode(FormContainer, {
        "validation-schema": _unref(validationSchema),
        class: "flex flex-col max-w-[25rem] items-center justify-center text-light-black",
        onValid: saveDetails
      }, {
        default: _withCtx(() => [
          _hoisted_1,
          _createElementVNode("div", _hoisted_2, [
            _createVNode(InputContainer, {
              modelValue: _unref(details).profile.name.first_name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(details).profile.name.first_name) = $event)),
              name: "firstName",
              placeholder: "First name*"
            }, null, 8, ["modelValue"]),
            _createVNode(InputContainer, {
              modelValue: _unref(details).profile.name.last_name,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(details).profile.name.last_name) = $event)),
              name: "lastName",
              placeholder: "Last name*"
            }, null, 8, ["modelValue"]),
            _createElementVNode("div", _hoisted_3, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(genderOption, (setup, index) => {
                return _createVNode(RadioContainer, {
                  id: `${index}_radio`,
                  key: `${setup}_ids`,
                  modelValue: _unref(details).profile.gender,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(details).profile.gender) = $event)),
                  name: "radio",
                  label: setup.name,
                  value: setup.value,
                  class: _normalizeClass(["flex flex-shrink h-10 w-fit cursor-pointer justify-center pt-5 rounded-4xl my-3 active:ring-1 active:ring-light-violet transition ease-in-out duration-200", _unref(details).profile.gender === setup.value ? 'bg-primary-violet text-white' : 'bg-light-gray-100'])
                }, {
                  icon: _withCtx(() => [
                    _createElementVNode("i", {
                      class: _normalizeClass(`${setup.icon}`)
                    }, null, 2)
                  ]),
                  _: 2
                }, 1032, ["id", "modelValue", "label", "value", "class"])
              }), 64))
            ]),
            _createVNode(InputContainer, {
              modelValue: _unref(details).profile.employment.role,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(details).profile.employment.role) = $event)),
              name: "profession",
              placeholder: "Profession"
            }, null, 8, ["modelValue"]),
            _createVNode(LocationContainer, {
              modelValue: _unref(details).profile.address.full_address,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(details).profile.address.full_address) = $event)),
              name: "address",
              "floating-suggestions": false,
              onLocation: _cache[5] || (_cache[5] = ($event: any) => (setLocation($event)))
            }, null, 8, ["modelValue"]),
            _createVNode(_component_ion_button, {
              expand: "block",
              type: "submit",
              "native-type": "submit"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Create my profile")
              ]),
              _: 1
            }),
            _hoisted_4
          ])
        ]),
        _: 1
      }, 8, ["validation-schema"])
    ]),
    _: 1
  }))
}
}

})